import { ChangeDetectorRef, Component, Inject, OnDestroy, AfterContentChecked } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { LoaderService } from './loader/loader.service';
import { KaizenService } from './Services/Kaizen.Service';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { filter, takeUntil } from 'rxjs/operators';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { TokenStorageService } from './Services/Token.Service';
import { Profile } from './models/Profile';
import { AspNetAppRoleService } from './Services/AspNetAppRoleService';
import { ProfileClaims } from './models/ProfileClaims';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { NotificationDTO } from './models/Kaizen'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnDestroy, AfterContentChecked {

  ngAfterContentChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  mobileQuery: MediaQueryList;

  isLoggedIn = false;
  isProduction = environment.production;
  hasReadNotifications = false;
  showNotifications = false;

  title = 'Regional Kaizen Planning System (REKAPS)';

  fillerNav = ['Home', 'Create New']
  sidenavWidth = 4;
  payLoadResult!: any;
  private accessToken = '';
  private readonly _destroying$ = new Subject<void>();

  public aduser: string = '';
  public ademail: string = '';
  public adrole: string = '';
  public adroleNormalized: string = '';

  public notification: NotificationDTO = { notificationCount: 0, notificationDetails: 'Loading details...' };

  public profile!: Profile[];
  public profileClaims: ProfileClaims = {
    seeKaizenList: true,
    submitKaizen: true,
    editDeleteKaizen: true,
    updateKaizenAfterApproval: true,
    planApprovalforBudget: true,
    editKaizenafterPlanApproved: true,
    addUserAccess: true,
    removeUserAccess: true
  };

  private _mobileQueryListener: () => void;

  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private tokenStorage: TokenStorageService,
    private changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, public loaderService: LoaderService,
    private aspNetAppRole: AspNetAppRoleService, private router: Router, private kaizenService : KaizenService
  ) {
    this.authService.handleRedirectObservable().subscribe({
      next: (resultAR: AuthenticationResult) => {
        if (resultAR) {
          this.authService.instance.setActiveAccount(resultAR?.account);
          this.setLoginFlag();
        }
      },
      error: (error) => console.log(error)
    });
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {
    this.sidenavWidth = 15;
    this.loaderService.isLoading.next(true);
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
      )
      .subscribe((result: EventMessage) => {
        this.payLoadResult = JSON.stringify(result.payload);
        this.accessToken = JSON.parse(this.payLoadResult)["accessToken"];
        localStorage.setItem("token", this.accessToken);
        this.tokenStorage.saveToken(this.accessToken);
      });
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginFlag();
      });
  }


  setLoginFlag() {
    this.isLoggedIn = this.authService.instance.getAllAccounts().length > 0;
    if (this.isLoggedIn) {
      const accinfo = this.authService.instance.getAllAccounts();
      this.aduser = accinfo[0].name!;
      this.ademail = accinfo[0].username!;
      localStorage.setItem("aduser", accinfo[0].name!);
      localStorage.setItem("ademail", accinfo[0].username!);
      this.aspNetAppRole.getAspNetUserRole(this.ademail)
        .subscribe(
          data => {
            this.profile = data.data.filter(x => x.active == true);
            if (this.profile.length != 0) {
              if (this.profile[0].active) {
                this.adrole = this.profile[0].name;
                this.adroleNormalized = this.profile[0].normalizedName;
                localStorage.setItem("userId", this.profile[0].userId);
                localStorage.setItem("companyId", this.profile[0].companyId.toString());
              }
            }
            else {
              this.adrole = `Viewer`;
              this.adroleNormalized = `Viewer`;
            }
            this.profileClaims = this.aspNetAppRole.setProfileClaim(this.adroleNormalized);
            localStorage.setItem("adrole", this.adrole);
            localStorage.setItem("adroleNormalized", this.adroleNormalized);
            localStorage.setItem(`userEmail`, this.ademail);
            localStorage.setItem(`profileClaims`, JSON.stringify(this.profileClaims));

            this.loaderService.isLoading.next(false);

            if (this.adroleNormalized === 'CMDApproverPlus' || this.adroleNormalized === 'CMDApprover') {
              this.showNotifications = true;

              // user is CMD Approver role so retrieve the kaizen notifications
              this.getNotificationKaizens();
            }
          },
          error => {

          }
        )
    }
    else {
      console.log('Trying to login again...');
      this.login();
    }
  }

  // unsubscribe to events when component is destroyed
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  shouldRun = /(^|.)(stackblitz|webcontainer).(io|com)$/.test(window.location.host);
  increase() {
    this.sidenavWidth = 15;
  }

  decrease() {
    this.sidenavWidth = 4;
  }

  login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      } else {
        this.authService.loginPopup()
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
      } else {
        this.authService.loginRedirect();
      }
    }
  }

  logout() {
    this.authService.logout();
  }

  showProfile() {
    this.router.navigate(['./userprofile']);
  }

  notificationClick() {
    this.hasReadNotifications = true;
    this.router.navigate(['./cmdreview']);
  }

  // getNotificationKaizens(): void 
  // {
  //   this.kaizenService.getNotificationKaizens(false, this.ademail).subscrwibe(data => this.notification = data, error => console.log(error), 
  //   () => {  }
  //   ); 
  // }
  getNotificationKaizens(): void {
  this.kaizenService.getNotificationKaizens(false, this.ademail).subscribe({
    next: data => this.notification = data,
    error: error => console.log(error),
    complete: () => { }
  });
}
}
